import { Institution } from '~/types/institution'
import NavItem from '~/components/NavItem'
import React from 'react'
import { Typography } from '@material-ui/core'

type ViewProps = {
    institutions?: Institution[]
}

export default ({ institutions }: ViewProps) => {
    const links = institutions?.map((institution, index) => (
        <span key={index}>
            ,{' '}
            <NavItem to={`/feed/${institution.slug}`} partiallyActive={true}>
                {institution.city}
            </NavItem>
        </span>
    ))

    return (
        <Typography variant="body1">
            Filter: <NavItem to="/feed">All</NavItem>
            {links}
        </Typography>
    )
}
